<template>
    <div class="share-layer" v-show="show_share" @click="isShow">
        <img src="@/assets/images/share.png" alt="">
    </div>
</template>
<script>
export default {
    name: "ShareLayer",
    props: {
        show_share:{
            type: Boolean
        }
    },
    methods:{
        isShow(){
            this.$emit('isShow',false);
        }
    }
}
</script>
<style scoped>
/* 分享图层 */
.share-layer{
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 1;
    width: 100%;
}
.share-layer img{
    width: 100%;
    height: 100%;
}
</style>





// WEBPACK FOOTER //
// src/components/hzjc/share-layer/Index.vue